import type { Account, AccountPayload } from "../types";
import { api } from "./core";

export const accountsApi = {
  accounts: (groupId: string) => api<Account[]>("/accounts", { groupId }),
  createAccount: (groupId: string, payload: AccountPayload) =>
    api<Account>("/accounts", { method: "POST", body: JSON.stringify(payload), groupId }),
  updateAccount: (groupId: string, id: string, payload: AccountPayload) =>
    api<Account>(`/accounts/${id}`, { method: "PATCH", body: JSON.stringify(payload), groupId }),
  deleteAccount: (groupId: string, id: string) =>
    api<void>(`/accounts/${id}`, { method: "DELETE", groupId }),
  restoreAccount: (groupId: string, id: string) =>
    api<Account>(`/accounts/${id}/restore`, { method: "POST", groupId }),
  emptyDeletedAccounts: (groupId: string) =>
    api<void>("/accounts/deleted", { method: "DELETE", groupId }),
};
